const OsservatoreStructure = {

    getStructure: function () {
        return {
            section : 
            {
                name: "Compila i seguenti campi",
                id: "osservatoreForm",
                description: "Sezione dedicata agli osservatori per le segnalazioni chiuse",
                multipleValue: false,
                rows : [
                    {
                        id : "row1",
                        fields : [
                            {
                                name: "divisionBar",
                                type: "bar",
                                numColMd: 12,
                                label: "state to funz",
                                tooltipText: "",
                                required: false,
                            }
                        ]
                    },
                    {
                        id : "row2",
                        fields : [
                            {
                                name: "firstRowDescription",
                                type: "firstRow",
                                numColMd: 12,
                                label: "",
                                required: false,
                                tooltipText: "",
                                
                            }
                        ]
                    },
                    {
                        id : "row3",
                        fields : [
                            {
                                name: "noteFunzionarioNotediTrasmissione",
                                type: "textArea",
                                numColMd: 12,
                                label: "Note Osservatore",
                                required: false,
                                tooltipText: "",
                            }
                        ]
                    }
            ]}  
        }
    }
}

export default OsservatoreStructure;